import "./Button.css";

function Button({ text, icon, variant, onClick = () => {}, className, id }) {
  if (variant === "complex") {
    return (
      <div className={`buttonContainer ${className}`} onClick={() => onClick()}>
        <button className="buttonBody">{text}</button>
        <span className="endButton">{icon}</span>
      </div>
    );
  }
  if (variant === "simple") {
    return (
      <div className={`buttonContainer ${className}`} onClick={() => onClick()}>
        <button className="buttonBody">
          {text}
          <span className="iconContainer">{icon}</span>
        </button>
      </div>
    );
  }
  if (variant === "supersimple") {
    return (
      <div className={`buttonContainer ${className}`} onClick={() => onClick()}>
        <button className="buttonBody">{text}</button>
      </div>
    );
  }
  if (variant === "icon") {
    return (
      <div className={`buttonContainer ${className}`} onClick={() => onClick()}>
        <span className="endButton" id={id}>
          {icon}
        </span>
      </div>
    );
  }
}

export default Button;
